export const isInstaMotion = (dataSource?: string) => dataSource === 'INSTAMOTION';
